<input
  type="text"
  [id]="id"
  [placeholder]="props.placeholder || ''"
  aria-label="Number"
  i18n-aria-label
  matInput
  [formControl]="formControl"
  [matAutocomplete]="auto2"
  [formlyAttributes]="field"
  autocomplete="id"
  (focus)="inputFocus$.next(true)"
  (blur)="inputFocus$.next(false)"
  #input
/>

<mat-autocomplete
  #auto2="matAutocomplete"
  [displayWith]="displayWith$ | async"
  (optionSelected)="onOptionSelected($event)"
  (closed)="autocompleteOpen$.next(false)"
  (opened)="autocompleteOpen$.next(true)"
>
  <ng-container *ngIf="props.options | laSelectOptions as options">
    <ng-container
      *ngFor="
        let item of options
          | async
          | filterWith
            : (value === undefined || value === null ? '' : input.value)
            : ['label', 'description']
      "
    >
      <mat-optgroup *ngIf="item.group" [label]="item.label">
        <mat-option
          *ngFor="let child of item.group"
          [value]="child.value"
          [disabled]="child.disabled"
        >
          {{ child.label }}
        </mat-option>
      </mat-optgroup>

      <mat-option
        *ngIf="!item.group"
        [value]="item.value"
        [disabled]="item.disabled"
      >
        <span class="d-flex flex-column">
          <span>{{ item.label }}</span>
          <span *ngIf="item.description" class="mat-small text-grayLight">
            {{ item.description }}
          </span>
        </span>
      </mat-option>
    </ng-container>
  </ng-container>
</mat-autocomplete>
